import { render, staticRenderFns } from "./AddInquiryProcess.vue?vue&type=template&id=116d801a&"
import script from "./AddInquiryProcess.vue?vue&type=script&lang=js&"
export * from "./AddInquiryProcess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports